<div class="ui-bar-chart__captions">
  @for (value of barChartValues; track $index) {
    <div>
      {{ value.caption }}
      @if (value.icon) {
        <campus-icon [svgIcon]="value.icon"></campus-icon>
      }
    </div>
  }
</div>
<div class="ui-bar-chart__tracks">
  @for (value of barChartValues; track $index) {
    <campus-chart-element
      [value]="value.percentage"
      [tooltip]="value.tooltip"
      [colorClass]="value.className"
      [size]="size"
      [showTrack]="showTrack || value.showTrack"
      [orientation]="orientation"
      (click)="chartClicked(value)"
    ></campus-chart-element>
  }
</div>
